<template>
  <div id="schedule">
    <Printer title="Course Schedule">
      <template v-slot:printContent>
        <div
          v-for="a in agendas"
          :key="a.Id"
          class="Page"
        >
          <div class="subreport-header">
            {{ a.AgendaName }}
          </div>
          <div class="row">
            <div class="startColumn pr-3 text-danger scheduleHeader">
              Start
            </div>
            <div class="titleColumn text-danger scheduleHeader">
              Title
            </div>
            <div class="presentColumn text-danger scheduleHeader">
              Presented By
            </div>
            <div class="locationColumn text-danger scheduleHeader">
              Location
            </div>
            <div class="qmColumn text-danger scheduleHeader">
              Quartermaster Info
            </div>
            <div class="currColumn text-danger scheduleHeader">
              Curr
            </div>
            <div class="audienceColumn text-danger scheduleHeader">
              Audience
            </div>
          </div>
          <div
            class="row pt-2 pb-2 border-bottom"
            v-for="ai in a.AgendaItems"
            :key="ai.Id"
          >
            <div class="startColumn pr-3 scheduleCell">
              {{ timeFormatter(ai.StartTime) }}
            </div>
            <div class="titleColumn scheduleCell">
              {{ ai.Topic }}
            </div>
            <div class="presentColumn scheduleCell">
              {{ getStaffName(ai.PresenterScouterKey) }}
            </div>
            <div class="locationColumn scheduleCell">
              {{ ai.LocationInfo }}
            </div>
            <div class="qmColumn scheduleCell">
              <div v-html="ai.QuartermasterInfo" />
            </div>
            <div class="currColumn scheduleCell">
              {{ ai.CurriculumReference }}
            </div>
            <div class="audienceColumn scheduleCell">
              {{ ai.Audience }}
            </div>
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'PrintCourseSchedule',
  components: {
    Printer
  },
  props: {
    agendas: {
      type: Array,
      default: function () {
        return []
      }
    },
    staff: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    timeFormatter: function (cellValue) {
      return formatter.formatAsTime(cellValue)
    },
    dateFormatter: function (params) {
      return formatter.formatAsDate(params)
    },
    getStaffName: function (scouterKey) {
      const scouter = this.staff[scouterKey]

      if (scouter === undefined) {
        return ''
      } else {
        return scouter
      }
    }
  }
}
</script>
